import styled from "styled-components";

import { Drawer } from "@material-ui/core";

export const Style = styled.div`
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2em;
  background: ${props => (props.homepage ? "#002e8c" : "white")};
  margin: 0;
  border-radius: 0;
  font-family: Poppins;
  position: fixed;
  width: 100vw;
  z-index: 100;
  /* position: fixed;
    width: 100%;
    z-index:100; */
  @media screen and (max-width: 600px) {
    height: 70px;
    padding: 1em;

    .ham {
      width: 40px;
    }
  }

  .navbarr {
    display: flex;
    margin-bottom: 0 !important;
    width: 100%;
  }

  .navbar__navbarLogo {
    width: 142px;
    height: 60px;
    @media screen and (max-width: 600px) {
      width: 120px;
      height: 60px;
      margin: auto;
    }
  }

  .navbar__navbarLinks {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #a1b5e0;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 3.2px;

    .link {
      @media screen and (max-width: 1200px) {
        display: none;
      }
      color: ${props => (props.homepage ? "#A1B5E0" : "#009EE4")};
    }

    .MuiSvgIcon-root {
      font-size: 32px;
      color: #fff;
    }

    & > a {
      cursor: pointer;
      transition: color 0.2s ease;
      text-decoration: none;

      &:hover {
        color: ${props => (props.homepage ? "white" : "#691AAA")};
      }
    }

    & > a:not(:last-child) {
      margin-right: 4em;
    }

    @media screen and (max-width: 1600px) {
      font-size: 14px;

      .MuiSvgIcon-root {
        font-size: 24px;
      }

      & > a:not(:last-child) {
        margin-right: 3em;
      }
    }
  }
  .inner {
    .navbar__navbarLinks {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #a1b5e0;
      text-transform: uppercase;
      font-weight: 600;

      font-size: 16px;
      letter-spacing: 3.2px;
    }
  }
  .purple {
    color: ${props => (props.homepage ? "white" : "#691AAA")} !important;
    font-weight: bold;
  }
`;

export const StyleDrawer = styled(Drawer)`
  .navbar__drawerLink {
    padding: 32px 1.4em;
    min-width: 220px;
    font-family: Poppins;
    background: #002e8c;
    text-align: right;
    justify-content: flex-end;
    color: #7689b0;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 2.4px;
    border-bottom: 1px solid #002062;
    font-weight: 600;

    @media screen and (max-width: 600px) {
    
      padding: 20px 1.4em;
    }
  }

  .white_ {
    color: #fff;
  }
  & > .navbar__drawerLink:first-child {
    border-top: 1px solid #a1b5e0;
  }

  @media screen and (max-width: 1600px) {
    padding: 20px 1em;
  }
`;
